import {useQuery} from '@tanstack/react-query'

import {QueryKeyName, getComments} from '../../common/backend'
import {usePlantUpmId} from '../usePlantUpmIdContext'

export const useComments = (questionId: string) => {
  const plantId = usePlantUpmId()
  return useQuery({
    queryKey: [QueryKeyName.GetComments, plantId, questionId],
    queryFn: () => getComments({plantId, questionId})
  })
}
